import axios, { type AxiosInstance } from 'axios';
import config from '../config';

// Create axios instance with default config
const createApiClient = (baseURL: string): AxiosInstance => {
  const client = axios.create({
    baseURL,
    withCredentials: true, // Important for cookie-based auth
    headers: {
      'Content-Type': 'application/json',
      'X-Client-Name': config.appName,
      'X-Client-Version': config.version,
    },
  });

  // Request interceptor to add auth token
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor for handling auth errors
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      // Don't clear token on 401 - let useAuth handle redirect
      return Promise.reject(error);
    }
  );

  return client;
};

// API clients for different services
export const authApi = createApiClient(config.authApiUrl);
export const portalApi = createApiClient(config.portalApiUrl);

export default authApi;
